// extracted by mini-css-extract-plugin
module.exports = {"container":"Onboarding_container__uA7h8","content":"Onboarding_content__DQsg1","details":"Onboarding_details__3BlEU","svg":"Onboarding_svg__1W_jh"};